import { INSURANCE_TYPES } from '../../../../../constants';
import { INSURANCE_DOCUMENT_SUB_TYPES } from '../../../../../pages/questionnaires/onboarding/components/forms/insurance/constants';

import type { IOnboardingQuestionnaireInsurance } from '../../../../../pages/questionnaires/onboarding/components/forms/insurance/types';
import type { OnboardingQuestionnaireState } from '../../types';

export function removeSecondaryInsuranceFromDetails(state: OnboardingQuestionnaireState) {
  const details = state.onboardingQuestionnaireDetails;
  if (!details) {
    return;
  }
  details.insurances = details.insurances.filter(
    (insurance) => insurance.insurance_type !== INSURANCE_TYPES.SECONDARY,
  );
  details.documents = details.documents.filter(
    (document) =>
      document.document_sub_type !== INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_FRONT &&
      document.document_sub_type !== INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_BACK,
  );
}

export function upsertInsurance(
  state: OnboardingQuestionnaireState,
  insurance: IOnboardingQuestionnaireInsurance,
) {
  const insurances = state.onboardingQuestionnaireDetails?.insurances;
  if (!insurances) return;

  const existingIndex = insurances.findIndex(
    (existing) => existing.insurance_type === insurance.insurance_type,
  );

  if (existingIndex >= 0) {
    insurances[existingIndex] = insurance;
  } else {
    insurances.push(insurance);
  }
}
